import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { GridList } from '@/components/ui/grid-list';
import type { ModuleLandingAction } from '@/config/modules/types';
import { hasMatchingPermission, usePermissions } from '@/hooks/use-permissions';

interface ModuleLandingPageProps {
  title: string;
  description: string;
  actions: ModuleLandingAction[];
}

export function ModuleLandingPage({ title, description, actions }: ModuleLandingPageProps) {
  const { permissions } = usePermissions();

  const filteredActions = useMemo(
    () =>
      actions.filter((action) => !action.code || hasMatchingPermission(action.code, permissions)),
    [actions, permissions],
  );

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.2 }}>
      <div className="flex flex-wrap items-center gap-6 sm:flex-nowrap">
        <div>
          <h1 className="text-base font-semibold leading-7 text-gray-900">{title}</h1>
          <p className="mt-2 text-sm text-gray-700">{description}</p>
        </div>
      </div>
      <div className="mt-10 flex flex-wrap items-center gap-6 sm:flex-nowrap">
        <GridList actions={filteredActions} className="bg-transparent" />
      </div>
    </motion.div>
  );
}
